import { render, staticRenderFns } from "./IconLeftWord.vue?vue&type=template&id=141f93e0&scoped=true"
import script from "./IconLeftWord.vue?vue&type=script&lang=js"
export * from "./IconLeftWord.vue?vue&type=script&lang=js"
import style0 from "./IconLeftWord.vue?vue&type=style&index=0&id=141f93e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f93e0",
  null
  
)

export default component.exports